import {
  Mode,
  SectionId,
} from "@mirage/service-typeahead-search/service/types";
import {
  and,
  exactQueryLength,
  hasAttachmentUploadFilenames,
  isModeIn,
  or,
} from "../utils/predicate-factory";

import type { typeahead } from "@mirage/service-typeahead-search/service/types";

export const TYPEAHEAD_SEARCH_SECTIONS: typeahead.PredicateSubject<typeahead.SectionId>[] =
  [
    {
      id: SectionId.Find,
      predicate: and(isModeIn(Mode.Default)),
    },
    {
      id: SectionId.Recommended,
      predicate: and(isModeIn(Mode.Find), exactQueryLength(0)),
    },
    {
      id: SectionId.Suggested,
      predicate: and(isModeIn(Mode.Ask), exactQueryLength(0)),
    },
    {
      id: SectionId.Recent,
      predicate: and(
        isModeIn(Mode.Ask, Mode.Find, Mode.Default),
        exactQueryLength(0),
      ),
    },
    {
      id: SectionId.Ask,
      predicate: and(isModeIn(Mode.Default)),
    },
    {
      id: SectionId.AskDash,
      predicate: and(isModeIn(Mode.Default), hasAttachmentUploadFilenames()),
    },
    {
      id: SectionId.Create,
      predicate: and(isModeIn(Mode.Organize)),
    },
    {
      id: SectionId.Draft,
      predicate: and(isModeIn(Mode.Default), exactQueryLength(0)),
    },
    {
      id: SectionId.DraftFromTemplate,
      predicate: and(isModeIn(Mode.Write)),
    },
    {
      id: SectionId.DraftFromTone,
      predicate: and(isModeIn(Mode.Write)),
    },
    {
      id: SectionId.DraftFromSource,
      predicate: and(isModeIn(Mode.Write)),
    },
    {
      id: SectionId.Organize,
      predicate: or(
        isModeIn(Mode.Organize),
        and(isModeIn(Mode.Default), exactQueryLength(0)),
      ),
    },
  ];
